module.exports = __webpack_public_path__ + "static/assets/550e80270aa0f1282364fb28270275ec.svg";